import { useQuery } from '@tanstack/react-query';
import { db, describeDbError } from '../lib/db';
import {
  ESTIMATE_LIST_COLUMNS,
  type EstimateListRow,
  type EstimateStatus,
  type SolutionType,
} from '../lib/estimateTypes';

export interface EstimateFilters {
  status?: EstimateStatus;
  solution_type?: SolutionType;
}

export function useEstimates(filters?: EstimateFilters) {
  return useQuery({
    queryKey: ['estimates', filters ?? {}],
    queryFn: async (): Promise<EstimateListRow[]> => {
      let query = db
        .from('estimates')
        .select(ESTIMATE_LIST_COLUMNS)
        .order('created_at', { ascending: false });

      if (filters?.status) query = query.eq('status', filters.status);
      if (filters?.solution_type) query = query.eq('solution_type', filters.solution_type);

      const { data, error } = await query;
      if (error) throw new Error(describeDbError(error, 'Could not load estimates.'));
      return (data ?? []) as EstimateListRow[];
    },
    staleTime: 60 * 1000,
  });
}
